import { addOnceEventListener } from './helpers';

/**
 * @mixin
 */
export default {
  mounted: function mounted() {
    var _this = this;

    addOnceEventListener(window, 'touchstart', function () {
      _this.$vuetify.touchSupport = true;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/util/touchSupport.js
// module id = 7Yl2
// module chunks = 0